<template>
  <transition name="fade">
    <section class="video-group-box content-box cover">
      <!-- 视频区块 -->
      <div class="video-wrapper">
        <p class="tit">
          <img :src="require('@/assets/images/video-title.png')" alt="" />
        </p>
        <div class="container vid-container">
          <div class="video-con" @click="play">
            <div class="preview">
              <img :src="background" alt="" />
            </div>
          </div>
        </div>
      </div>
      <!-- 新闻区块 -->
      <div class="container news-container">
        <div class="context">
          <div class="header">时事动态</div>

          <swiper
            class="zjzb-swiper"
            :options="recordSwiperOption"
            :not-next-tick="true"
            ref="roundSwiper"
            @slideChange="changeSlide"
          >
            <swiper-slide v-for="(item, index) in list" :key="index">
              <NewsEntity
                :key="item.id"
                :id="item.id"
                :cover="item.cover"
                :title="item.title"
                :summary="item.summary"
                :active="index === slideIndex"
                @read="$emit('read', item)"
              />
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
          </swiper>
        </div>
      </div>
    </section>
  </transition>
</template>
<script>
import SectionTitle from '@/components/items/sectionTitle'
import NewsEntity from '@/components/items/NewsEntity'
export default {
  name: 'Video',
  components: { SectionTitle, NewsEntity },
  data() {
    return { slideIndex: 0 }
  },
  computed: {
    newImage() {
      return require('../../assets/images/new@2x.png')
    },
    footballImage() {
      return require('../../assets/images/football@2x.png')
    },
    playImage() {
      return require('../../assets/images/play_btn@2x.png')
    },
    videoUrl() {
      return ''
    },
    background() {
      const name = this.team || 'wolves'
      console.log(`../../assets/images/common/bg/${name}.png`)
      
      return require(`../../assets/images/common/bg/${name}.png`)
    },
    swiper() {
      const en = this.$refs.roundSwiper
      return (en && en.$swiper) || (en && en.$el.swiper)
    },
    list() {
      return this.listData
    },
    recordSwiperOption() {
      return {
        speed: 1000,
        spaceBetween: 5,
        autoplay: { delay: 4000, disableOnInteraction: false },
        // loop: true,
        grabCursor: true,
        slideToClickedSlide: true,
        autoplayDisableOnInteraction: false,

        slidesPerView: 'auto',
        centeredSlides: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        onSlideChangeEnd: function (swiper) {
          // swiper.update(); //swiper更新
        },
      }
    },
  },
  props: ['team', 'listData'],
  methods: {
    play() {
      this.$emit('play')
    },
    changeSlide(event) {
      this.slideIndex = this.$refs.roundSwiper.$el.swiper.realIndex
    },
  },
}
</script>

<style lang="less" scoped>
@import '../../assets/css/home';
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
<style lang="less">
@import '../../styles/home';
</style>

<style lang="less" scoped>
// .content-box.cover {
//   position: relative;
//   // display: flex;
//   // justify-content: center;
//   // align-items: center;
//   background-image: url('../../assets/images/common/bg-1.jpg');
//   background-size: cover;
//   background-position: top center;
//   background-repeat: no-repeat;
// }

.section-title-wrap {
  width: 60%;
  top: 2.2em;
  display: block;
  margin: 0 auto;
  z-index: 1;
  position: absolute;
}
.vid-container {
  width: 92.5%;
  margin: 0 auto;
  // margin-top:.5rem;
  margin-bottom: 0.443514644rem;
  // margin-top: 1.2em;
  // background: white;
  min-height: 20px;
  & > .video-con > .preview {
    background: no-repeat url(../../assets/images/common/bg/common.jpg);
    background-size: 100% 100%;
  }
}
.news-container {
  overflow: hidden;
  width: 92.5%;
  margin: 20px auto;
  display: flex;
  align-items: center;
  justify-content: center;
  // background: #efefef;
  .context {
    margin-bottom: 20px;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
    width: 100%;
  }
  .header {
    width: 80px;
    text-align: center;
    background: url('../../assets/images/title-bg.png') no-repeat left bottom;
    background-size: 100%;
    font-size: 16px;
    margin-bottom: 10px;
    font-weight: 600;
    padding-bottom: 3px;
  }
  .swiper-container-horizontal {
    overflow: visible;

    & > .swiper-pagination-bullets {
      bottom: auto;
      font-size: 0.4rem;
      top: 100%;
      /deep/ .swiper-pagination-bullet {
        width: 0.8rem;
        border-radius: 0.2rem;
        background: #efefef;
        opacity: 1;
        &.swiper-pagination-bullet-active {
          background: #ff9432;
        }
      }
    }
  }
}
</style>
<style lang="stylus" scoped>
.video-wrapper {
  padding 20px 10px
  background url('../../assets/images/video-bg.jpg') center / cover
  .tit {
    text-align center
    img {
      width 116px
      margin 0 auto
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/section/video.vue